import { render, staticRenderFns } from "./AddMembershipModal.vue?vue&type=template&id=712512ae"
import script from "./AddMembershipModal.vue?vue&type=script&lang=ts"
export * from "./AddMembershipModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports